/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Charts_EmptyInputs */

const en_us2_exercise_sheet_charts_empty = /** @type {(inputs: Exercise_Sheet_Charts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do 1 workout with this exercise to see your charts.`)
};

const pt_br2_exercise_sheet_charts_empty = /** @type {(inputs: Exercise_Sheet_Charts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça 1 treino com este exercício para ver seus gráficos.`)
};

const es_419_exercise_sheet_charts_empty = /** @type {(inputs: Exercise_Sheet_Charts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz 1 entrenamiento con este ejercicio para ver tus gráficas.`)
};

const pt_pt2_exercise_sheet_charts_empty = /** @type {(inputs: Exercise_Sheet_Charts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faz 1 treino com este exercício para veres os teus gráficos.`)
};

const fr_fr2_exercise_sheet_charts_empty = /** @type {(inputs: Exercise_Sheet_Charts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fais 1 séance avec cet exercice pour voir tes graphiques.`)
};

const de_de2_exercise_sheet_charts_empty = /** @type {(inputs: Exercise_Sheet_Charts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mach 1 Training mit dieser Übung, um deine Diagramme zu sehen.`)
};

const it_it2_exercise_sheet_charts_empty = /** @type {(inputs: Exercise_Sheet_Charts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai 1 allenamento con questo esercizio per vedere i tuoi grafici.`)
};

/**
* | output |
* | --- |
* | "Do 1 workout with this exercise to see your charts." |
*
* @param {Exercise_Sheet_Charts_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_charts_empty = /** @type {((inputs?: Exercise_Sheet_Charts_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Charts_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_charts_empty(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_charts_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_charts_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_charts_empty(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_charts_empty(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_charts_empty(inputs)
	return en_us2_exercise_sheet_charts_empty(inputs)
});
export { exercise_sheet_charts_empty as "exercise-sheet.charts_empty" }